<template>
  <UiPillNavBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { ITabNavOption } from '@team-milva/lab-components'

export default {
  name: 'UiPillNav',
  inheritAttrs: false,
  props: {
    navItems: { type: Array as PropType<ITabNavOption[]>, default: () => [] },
  },
}
</script>

<style>
@reference "../../globals/css/base.css";

.s-pill-nav .s-pill-nav__item {
  @apply bg-surface-muted text-text-secondary hover:bg-surface-sunken;

  &.is-active {
    @apply bg-action text-white;
  }
}
</style>
